import { STORAGE_LIMITS } from '@/constants/constants'
import type { StorageState } from '@/types/state'

export const storageState: StorageState = {
  items: [],
  limits: STORAGE_LIMITS,
  quota: null,
}
